import axios from "axios";
import { IDefaultKeywordFamily } from "../types/types";

export async function checkIfDuplicateSlug(slug: string): Promise<boolean> {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/api/check-if-slug-duplicate`,
      {
        slug,
      }
    );
    return response?.data?.message;
  } catch (error) {
    throw new Error("Error checking slug uniqueness");
  }
}

export async function checkIfTypos(text: string): Promise<string[]> {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/api/spellcheck/`,
      {
        text,
      }
    );
    return response?.data?.misspelled_words || [];
  } catch (error) {
    throw new Error("Error checking for typos");
  }
}

export function hasArrayChanged<T>(arr1: Array<T>, arr2: Array<T>): boolean {
  if (arr1.length !== arr2.length) return true;
  return !arr1.every(
    (element, index) => JSON.stringify(element) === JSON.stringify(arr2[index])
  );
}

export function galleryPhotosUpdated(
  // eslint-disable-next-line
  originalLandingPageData: any,
  // eslint-disable-next-line
  globalStateAtom: any
): boolean {
  const originalGalleryPhotos = originalLandingPageData?.gallery || [];
  const galleryPhotosHaveChanged = hasArrayChanged(
    originalGalleryPhotos,
    globalStateAtom?.gallery
  );

  return galleryPhotosHaveChanged;
}

export function heroPhotosUpdated(
  // eslint-disable-next-line
  originalLandingPageData: any,
  // eslint-disable-next-line
  globalStateAtom: any
): boolean {
  const originalHeroPhotos = originalLandingPageData?.hero_gallery_photos || [];
  const heroPhotosHaveChanged = hasArrayChanged(
    originalHeroPhotos,
    globalStateAtom?.hero_gallery_photos
  );

  return heroPhotosHaveChanged;
}

export const searchKeywordFamily = async (
  industry: string,
  searchForNewKeywords = false
): Promise<IDefaultKeywordFamily> => {
  try {
    const response = await axios.get<{ message: IDefaultKeywordFamily[] }>(
      `${process.env.REACT_APP_SERVER_URL}/api/seo/default-keyword-families/search`,
      {
        params: {
          industry,
          search_for_new_service_keywords: searchForNewKeywords,
        },
      }
    );
    return response.data.message[0];
  } catch (error) {
    throw new Error("Error fetching keyword family");
  }
};
